import React, {useState} from "react";
import {css, cx} from "@panda/css";

import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";

interface IProps {
    className?: string;
    content?: React.ReactNode;
    coverClassName?: string;
    rightSlot?: React.ReactNode;
    title: string;
    address: string;
    imgSrc?: string;
}

export const ApplicationMultiLeadFormOfferBoxBase = (props: IProps) => {
    return (
        <div className={cx(wrapperStyle, props.className)}>
            <div className={cx(offerCoverStyle, props.coverClassName)}>
                <Image src={props.imgSrc} width="100%" height="130px" alt="" className={imgCoverStyle} />
            </div>
            <div className={contentStyle}>
                <Text variant="body_copy_2" mb={0.5}>
                    {props.title}
                </Text>
                <Text variant="info_txt_3" mb={0.5} color="var(--colors-gray-700)">
                    {props.address}
                </Text>
                {props.content}
            </div>
            {props.rightSlot ? <div>{props.rightSlot}</div> : null}
        </div>
    );
};

ApplicationMultiLeadFormOfferBoxBase.Logo = (props: {imgSrc?: string; alt: string; className?: string}) => {
    const [hasError, setHasError] = useState(false);
    return (
        <div className={cx(!hasError && logoWrapperStyle, props.className)}>
            {!hasError && <Image src={props.imgSrc} width="64px" height="48px" alt={props.alt} onError={() => setHasError(true)} />}
        </div>
    );
};

const wrapperStyle = css({
    display: "flex",
    flexDirection: "row",
    position: "relative",
    borderRadius: 1,
    backgroundColor: "#fff"
});

const offerCoverStyle = css({
    borderTopLeftRadius: 1,
    borderBottomLeftRadius: 1,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    flex: "0 0 96px",
    overflow: "hidden"
});

const imgCoverStyle = css({
    display: "block",
    height: "100%",
    "& img": {
        height: "100%",
        objectFit: "cover"
    }
});

const contentStyle = css({
    padding: 1,
    flex: "1 1 100%",
    display: "flex",
    flexDirection: "column"
});

const logoWrapperStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    width: "6.4rem",
    height: "4.8rem"
});
import React, {useState} from "react";
import {css, cx} from "@panda/css";

import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";

interface IProps {
    className?: string;
    content?: React.ReactNode;
    coverClassName?: string;
    rightSlot?: React.ReactNode;
    title: string;
    address: string;
    imgSrc?: string;
}

export const ApplicationMultiLeadFormOfferBoxBase = (props: IProps) => {
    return (
        <div className={cx(wrapperStyle, props.className)}>
            <div className={cx(offerCoverStyle, props.coverClassName)}>
                <Image src={props.imgSrc} width="100%" height="130px" alt="" className={imgCoverStyle} />
            </div>
            <div className={contentStyle}>
                <Text variant="body_copy_2" mb={0.5}>
                    {props.title}
                </Text>
                <Text variant="info_txt_3" mb={0.5} color="var(--colors-gray-700)">
                    {props.address}
                </Text>
                {props.content}
            </div>
            {props.rightSlot ? <div>{props.rightSlot}</div> : null}
        </div>
    );
};

ApplicationMultiLeadFormOfferBoxBase.Logo = (props: {imgSrc?: string; alt: string; className?: string}) => {
    const [hasError, setHasError] = useState(false);
    return (
        <div className={cx(!hasError && logoWrapperStyle, props.className)}>
            {!hasError && <Image src={props.imgSrc} width="64px" height="48px" alt={props.alt} onError={() => setHasError(true)} />}
        </div>
    );
};

const wrapperStyle = css({
    display: "flex",
    flexDirection: "row",
    position: "relative",
    borderRadius: 1,
    backgroundColor: "#fff"
});

const offerCoverStyle = css({
    borderTopLeftRadius: 1,
    borderBottomLeftRadius: 1,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    flex: "0 0 96px",
    overflow: "hidden"
});

const imgCoverStyle = css({
    display: "block",
    height: "100%",
    "& img": {
        height: "100%",
        objectFit: "cover"
    }
});

const contentStyle = css({
    padding: 1,
    flex: "1 1 100%",
    display: "flex",
    flexDirection: "column"
});

const logoWrapperStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    width: "6.4rem",
    height: "4.8rem"
});
